const cards = [
  {
    title: '悬疑烧脑剧场',
    desc: '高分悬疑片与烧脑神剧合集，每一部都让你猜不到结局，沉浸式推理体验，适合深夜挑战智商的影迷。',
    tag: '热门分类',
    img: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20cinematic%20scene%20with%20warm%20amber%20lighting%2C%20shadowy%20film%20noir%20aesthetic%2C%20detective%20office%20with%20venetian%20blind%20shadows%2C%20vintage%20movie%20poster%20style%2C%20rich%20contrast%2C%20atmospheric%20composition&width=600&height=400&seq=card-suspense&orientation=landscape',
  },
  {
    title: '动作大片精选',
    desc: '肾上腺素飙升的经典动作电影，从好莱坞巨制到华语功夫片，燃爆你的周末观影时光。',
    tag: '热门分类',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20action%20scene%20with%20dramatic%20explosion%20silhouette%2C%20warm%20golden%20hour%20lighting%2C%20urban%20cityscape%20backdrop%2C%20movie%20poster%20aesthetic%2C%20epic%20scale%2C%20filmic%20color%20grading%20with%20teal%20and%20orange%20tones&width=600&height=400&seq=card-action&orientation=landscape',
  },
  {
    title: '温情治愈动画',
    desc: '适合全家一起看的暖心动画电影，从宫崎骏经典到皮克斯佳作，治愈你的每一个周末。',
    tag: '编辑精选',
    img: 'https://readdy.ai/api/search-image?query=Warm%20and%20cozy%20animated%20scene%20with%20soft%20pastel%20color%20palette%2C%20dreamy%20fantasy%20landscape%20with%20floating%20lanterns%2C%20gentle%20golden%20sunset%20lighting%2C%20whimsical%20storybook%20aesthetic%2C%20hand-drawn%20texture%20feel&width=600&height=400&seq=card-animation&orientation=landscape',
  },
  {
    title: '国产热播剧集',
    desc: '追剧党必看！最新国产电视剧同步更新，古装、都市、悬疑应有尽有，每天都有新剧集上线。',
    tag: '每日更新',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20period%20drama%20scene%20with%20traditional%20architecture%2C%20warm%20lantern%20lighting%2C%20misty%20mountain%20backdrop%2C%20cinematic%20composition%2C%20rich%20fabric%20textures%2C%20golden%20and%20crimson%20color%20palette&width=600&height=400&seq=card-drama&orientation=landscape',
  },
  {
    title: '喜剧笑声不断',
    desc: '开心麻花、周星驰经典、好莱坞喜剧——笑到停不下来的爆笑电影合集，解压神器在此。',
    tag: '热门分类',
    img: 'https://readdy.ai/api/search-image?query=Bright%20and%20vibrant%20comedy%20cinema%20scene%2C%20playful%20retro%20movie%20theater%20aesthetic%20with%20colorful%20popcorn%20and%20vintage%20film%20reels%2C%20warm%20lighting%2C%20joyful%20atmosphere%2C%20bold%20primary%20colors&width=600&height=400&seq=card-comedy&orientation=landscape',
  },
  {
    title: '科幻史诗巨制',
    desc: '从星际穿越到流浪地球，震撼视觉的科幻大片专题，带你在家体验IMAX级别的观影震撼。',
    tag: '视觉盛宴',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20scene%20with%20stunning%20nebula%20and%20distant%20galaxy%2C%20epic%20space%20landscape%2C%20dramatic%20lighting%20with%20deep%20blues%20and%20warm%20golden%20accents%2C%20film%20poster%20aesthetic%2C%20grand%20scale&width=600&height=400&seq=card-scifi&orientation=landscape',
  },
  {
    title: '高分纪录片',
    desc: 'BBC、国家地理高分纪录片专题，自然、历史、人文全覆盖，足不出户看遍世界精彩。',
    tag: '知识充电',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20documentary%20nature%20scene%20with%20majestic%20mountain%20landscape%20at%20golden%20hour%2C%20warm%20natural%20lighting%2C%20rich%20earthy%20tones%2C%20National%20Geographic%20aesthetic%2C%20breathtaking%20vista%2C%20lens%20flare&width=600&height=400&seq=card-documentary&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm max-w-xl mx-auto">
              精心挑选各类型高分影视作品，总有一部适合你的口味
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {cards.map((card, i) => (
              <div
                key={i}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading={i < 4 ? undefined : 'lazy'}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="inline-block px-2.5 py-1 bg-primary-500/90 text-background-50 text-xs font-medium rounded-md">
                      {card.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-semibold text-foreground-900 text-sm mb-1.5">{card.title}</h3>
                  <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">{card.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}